/**
 * @Author proudlx
 * @Description http请求封装 请求与响应拦截
 */
import { configMap, successCode, networkErrorMsg } from "./config";
import axios, { AxiosRequestConfig, AxiosResponse, Method } from "axios";
import store from "@/store";
import router from "@/router";
import MD5 from "md5";
import { randomString } from "@/utils";
import { ElNotification } from "element-plus";
import { i18n } from "@/language/local";
let ElNotificationRef: any = null;

const defaultConfig = { ...axios.defaults, ...configMap["default"] };
const requestInstance = axios.create(defaultConfig);
requestInstance.defaults.withCredentials = true;

export interface DefineResponse<D> {
  msg: string;
  code: number;
  data: D;
}
// 请求拦截
requestInstance.interceptors.request.use(
  (config) => {
    // 和服务端协商后，在这里处理header config.headers
    if (localStorage.getItem(process.env.VUE_APP_TOKEN_KEY)) {
      config.headers[process.env.VUE_APP_TOKEN_KEY] = localStorage.getItem(
        process.env.VUE_APP_TOKEN_KEY
      );
    }
    if (localStorage.getItem(process.env.VUE_APP_VISITOR)) {
      config.headers[process.env.VUE_APP_VISITOR] = localStorage.getItem(
        process.env.VUE_APP_VISITOR
      );
    }
    const str = randomString();
    if (config.data) {
      config.data.marketId = store.state.user.marketDataId || undefined;
    } else {
      config.data = { marketId: store.state.user.marketDataId || undefined };
    }
    // const aaa = randomString();
    // console.log(MD5("{}" + aaa), aaa, new Date().getTime());
    config.headers["service-hash"] = MD5(JSON.stringify(config.data) + str);
    config.headers["service-nonce"] = str;
    config.headers["service-date"] = new Date().getTime();
    config.headers["way-os-system"] = "api-system";
    config.headers["locale-language"] =
      config.headers["locale-language"] ||
      localStorage.getItem(process.env.VUE_APP_LANGURAGE as string) ||
      "zh-CN";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 响应拦截
requestInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject({ cancel: true, message: error.message });
    } else {
      return Promise.reject(error);
    }
  }
);

/* 请求封装 */
function request<T>(
  url: string,
  method: Method,
  data = {},
  option: any
): Promise<DefineResponse<T>> {
  // 正常接口进行
  return new Promise((resolve, reject) => {
    requestInstance({
      url,
      method,
      data: method !== "get" ? data : null,
      params: method === "get" ? data : null,
      onUploadProgress: (progressEvent) => {
        if (option.uploadprogress) {
          option.uploadprogress(progressEvent);
        }
      },
      ...option,
    })
      .then((resp: AxiosResponse<any>) => {
        console.log("接口返回", resp);
        if (resp.data.code === "405") {
          console.log("405暂无权限，跳转405页面");
          router.replace("/405");
          return reject(resp.data);
        }
        if (resp.status === 200 && successCode.includes(resp.data.code)) {
          const filterResponse = JSON.parse(
            JSON.stringify(resp.data, (key, value) => {
              if (key === "class") {
                return undefined;
              } else {
                return value;
              }
            })
          );
          resolve(filterResponse);
        } else if (resp.data.code === "03") {
          console.log("03登录过期，跳转登录页", resp);
          if (resp.config?.url?.indexOf("big6sea") !== -1) {
            return router.replace("/operate/loginBefore");
          }
          if (window.location.href.indexOf("agentReport") !== -1) {
            if (window.matchMedia("(max-width: 767px)").matches) {
              return router.replace("/mobile/loginBefore");
            }else{
              return router.replace("/operate/loginBefore");
            }
          }
          store.dispatch("Logout").then(() => {
            router.replace("/");
            // 调用tt4b登录页面
            // store
            //   .dispatch("LoginBefore")
            //   .then(() => {
            //     reject(resp.data);
            //   })
            //   .catch((err) => {
            //     console.info("登录异常", err);
            //   });
          });
        } else if (resp.data.code === "404") {
          router.replace("/404");
          reject(resp.data);
        } else if (resp.data.code === "403") {
          // window.location.href = "https://ads.tiktok.com/i18n/forbidden";
          router.replace("/403");
          // store.dispatch("Logout").then(() => {
          //   // 调用tt4b无权限页面
          //   window.location.href = "https://ads.tiktok.com/i18n/forbidden";

          //   reject(resp.data);
          // });
        } else if (
          resp.status === 200 &&
          option.responseType == "arraybuffer"
        ) {
          resolve(resp.data);
        } else {
          const respData = Object.assign(
            typeof resp.data === "object" ? resp.data : { data: resp?.data },
            { businessError: true }
          );
          console.log("respData", respData);
          reject(respData);
        }
      })
      .catch((error) => {
        console.log("接口异常", error);
        if (
          error.message == "Network Error" ||
          error.message.indexOf("timeout") > -1
        ) {
          error = new Error("网络错误，请检查您的网络连接");
        }
        if (error.response) {
          const errorData = {
            code: error.response.status,
            data: error.response.data,
            msg: networkErrorMsg.replace(
              "{0}",
              error.response.status + 1000000
            ),
            netError: true,
          };
          if (error.response.status === 400 && !ElNotificationRef) {
            ElNotificationRef = ElNotification({
              title: i18n.global.t("登录失败"),
              dangerouslyUseHTMLString: true,
              duration: 0,
              message: `<div class="notification-loginError-message">${i18n.global.t(
                "如您在登陆过程中遇到问题请点击解决方案文档并按步骤操作，如仍无法登陆，请联系人工客服解决"
              )}
                  <br/>
                  <div class="btn">${i18n.global.t("解决方案")}</div>
                </div>`,
              onClick: () => {
                window.open(
                  "https://bytedance.sg.larkoffice.com/wiki/RC1kwY6xBihyeTkH4dUcdNn8nhf"
                );
              },
            });
          }
          reject(errorData);
          //   if (option.canToast !== false) {
          //     errorMessage(errorData.msg);
          //   }
        } else {
          reject(error);
        }
      });
  });
}
export default {
  get<T>(url: string, params = {}, option = {}): Promise<DefineResponse<T>> {
    return request(url, "get", params, option);
  },
  post<T>(url: string, data = {}, option = {}): Promise<DefineResponse<T>> {
    return request(url, "post", data, option);
  },
  postJson<T>(
    url: string,
    data = {},
    option: any = {}
  ): Promise<DefineResponse<T>> {
    option.configStr = `${option.configStr || ""}-jsonheader`;
    return request(url, "post", data, option);
  },
  uploadFile<T>(
    url: string,
    data: any,
    option: any
  ): Promise<DefineResponse<T>> {
    const formData = new FormData();
    for (const k in data) {
      if (data(k)) {
        formData.append(k, data[k]);
      }
    }
    option.configStr = `${option.configStr || ""}-fileheader-long`;
    return request(url, "post", formData, option);
  },
};
